import request from "@/utils/request";

// 用户相关接口
// export const getHomeAjax = {
//   getTcTrainArticle(data) {
//     return request({
//       url: "/tcOfficialWeb/api/getTcTrainArticle",
//       method: "get",
//       params: data,
//     });
//   },
// }; 

// // 获取轮播图列表
// export const getPictureList = () => {
//   return request({
//     url: '/tcOfficialWeb/api/getCarouselList',
//     method: 'get'
//   })
// }

//查询新闻动态
export const getNewsMessage = (data) => {
  return request({
    url: "/pc/online/lt/getNewsMessage",
    method: "get",
    params: data,
  });
};

//师资查询
export const getTeachers = (data) => {
  return request({
    url: "/pc/online/lt/getTeachers",
    method: "get",
    params: data,
  });
};

//专家查询
export const getSpecialist = (data) => {
  return request({
    url: "/pc/online/lt/getSpecialist",
    method: "get",
    params: data,
  });
};

//项目开发列表分页查询
export const getLtItemDaList = (data) => {
  return request({
    url: "/pc/online/lt/getLtItemDaList",
    method: "get",
    params: data,
  });
};

//研究院简介
export const getLtLanTaiDaList = (data) => {
  return request({
    url: "/pc/online/lt/getLtLanTaiDaList",
    method: "get",
    params: data,
  });
};

//获取新闻列表
export const getNewsList = (data) => {
  return request({
    url: "/pc/online/lt/getNewsMessage",
    method: "get",
    params: data,
  });
};

//获取项目列表
export const getProjectList = (data) => {
  return request({
    url: "/pc/online/lt/getLtItemDaList",
    method: "get",
    params: data,
  });
};


//教学计划
export const getTeachingProgram = (data) => {
  return request({
    url: "/pc/online/lt/getTeachingProgram",
    method: "get",
    params: data,
  });
};

//课程规划
export const getCoursePlanningDalist = (data) => {
  return request({
    url: "/pc/online/lt/getCoursePlanningDalist",
    method: "get",
    params: data,
  });
};

//课程
export const getLtCourseVideoDalist = (data) => {
  return request({
    url: "/pc/online/lt/getLtCourseVideoDalist",
    method: "get",
    params: data,
  });
};


//获取政策列表
export const getLtCodificationDalist = (data) => {
  return request({
    url: "/pc/online/lt/getLtCodificationDalist",
    method: "get",
    params: data,
  });
};

//获取政策详情
export const getLtCodificationDa = (id) => {
  return request({
    url: "/pc/online/lt/getLtCodificationDa/" + id,
    method: "get",
  });
};

//人才招聘
export const getLtTalentRecruitmentDalist = (data) => {
  return request({
    url: "/pc/online/lt/getLtTalentRecruitmentDalist",
    method: "get",
    params: data,
  });
};


//获取文章具体信息
export const getNewsMessageById = (data) => {
  return request({
    url: "/pc/online/lt/getNewsMessageById",
    method: "get",
    params: data,
  });
};

//获取职位详情
export const getLtTalentRecruitmentDetail = (id) => {
  return request({
    url: "/pc/online/lt/getLtTalentRecruitmentDetail",
    method: "get",
    params: {
      id
    },
  });
};

// /pc/online/lt/getLtItemDaInfo 项目开发详细信息
export const getLtItemDaInfo = (id) => {
  return request({
    url: "/pc/online/lt/getLtItemDaInfo/" + id,
    method: "get",
  });
};
// 官网项目研究根据文件类型查询绑定的资源/pc/online/lt/getBandingList
export const getBandingList = (params) => {
  return request({
    url: "/pc/online/lt/getBandingList",
    method: "get",
    params,
  });
};

// /pc/online/lt/CertificateOtherImgWx查询别人的证书 Copy
export const getCertificateOtherImgWx = (data) => {
  return request({
    url: "/pc/online/lt/CertificateOtherImgWx",
    method: "get",
    params: data,
  });
};